/**
 * This is a React component that displays a category item and handles the click event to filter
 * products by category.
 * @returns A functional component named `CategoryItems` is being returned.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { getCategoriesFilterAction } from "../../State/actions/CategoriesFilterAction";
import { clearBrandAction } from "../../State/actions/BrandFilterActions";
import { useDispatch } from "react-redux";
import { defaultCategory } from "../../utils/productUtils/ProductUtils";

const CategoryItems = ({ categoryObj }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const addCategoriesFilter = async (id, categoryName) => {
    window.scrollTo(0, 0);
    // dispatch(clearBrandAction());
    // await dispatch(getCategoriesFilterAction(id, categoryName));
    if (window.innerWidth <= 768) {
      navigate("/category/" + categoryObj.categoryId, {
        state: categoryObj,
      });
    } else {
      navigate(`/shop/${id}`, { replace: true });
    }
  };

  return (
    <div
      key={categoryObj.categoryid}
      className="categoryListBox"
      onClick={() =>
        addCategoriesFilter(categoryObj.categoryId, categoryObj.categoryName)
      }
    >
      <div className="categoryListItem">
        <div className="categoryListImage">
          <img
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = defaultCategory;
            }}
            src={categoryObj.categoryLogo || defaultCategory}
            alt={categoryObj.categoryName}
          />
        </div>
        {/* <h1
          className="mb-0 mt-2"
          dangerouslySetInnerHTML={{
            __html: categoryObj.categoryName,
          }}
        ></h1> */}
      </div>
      <h1
        className="mb-0 mt-2"
        dangerouslySetInnerHTML={{
          __html: categoryObj.categoryName,
        }}
      ></h1>
    </div>
  );
};

export default CategoryItems;
